<template>
  <footer class="app-footer"  :class="isDark ? 'bg-dark text-light' : ''">
    <!--<span><a href="http://www.hayhudev.com.br">CEC Web</a> &copy; 2025.</span> -->
    <span>Usuário: {{ usuario }}</span>
    <span class="ml-auto">Por <a :class="isDark ? 'text-light' : ''" href="http://www.hayhudev.com.br">HayHu Tecnologia</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  data: function() {
    return {
      usuario: ''
    }
  },
  mounted () {
    this.usuario = window.localStorage.getItem('nomeusuario')
    
  },
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK'] 
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue